import React, { MouseEvent, useRef } from 'react';
import { Link, Typography } from 'common/components';
import { useIntersection } from 'common/hooks';
import { RelatedService } from 'modules/related-services';
import { createElementKey } from 'utils';
import { formatToRub } from 'utils/format';
import {
  productInfoServices,
  productInfoServiceWrapper,
  productInfoServicePriceWrapper,
} from './product-services-styles';

type ProductServicesProps = {
  activeServices: RelatedService[];
  onServiceClick: (service: RelatedService, position: number) => void;
  onServiceShowEvent: ((service: RelatedService, position: number) => void) | undefined;
  prefixPrice: string | undefined;
  serviceDisclaimer?: React.ReactNode;
};

export const ProductServices: React.FC<ProductServicesProps> = ({
  activeServices,
  onServiceClick,
  onServiceShowEvent,
  prefixPrice,
  serviceDisclaimer,
}) => {
  const productRef = useRef<HTMLAnchorElement[]>([]);

  useIntersection(productRef, el => {
    if (!onServiceShowEvent) {
      return;
    }

    const position = el.getAttribute('data-position');

    if (!position) {
      return;
    }

    const numberPosition = Number(position);
    onServiceShowEvent(activeServices[numberPosition], numberPosition);
  });

  const handleServiceClick = (index: number) => () => {
    const service = activeServices[index];

    onServiceClick(service, index);
  };

  const handleServiceWheelClick = (index: number) => (e: MouseEvent) => {
    if (e.button === 1) {
      handleServiceClick(index);
    }
  };

  return (
    <div className={productInfoServices}>
      <Typography variant="m" size="subtitle">
        Закажите услуги:
      </Typography>

      {activeServices.map((service, index) => (
        <Link
          className={productInfoServiceWrapper}
          data-position={index}
          href={service.serviceURL}
          onClick={handleServiceClick(index)}
          onAuxClick={handleServiceWheelClick(index)}
          key={createElementKey('product-service', index)}
          refCb={(el: HTMLAnchorElement) => {
            if (el) productRef.current[index] = el;
          }}
          title={service.title}>
          <img alt={service.title} height={40} src={service.imageUrl} title={service.title} width={40} />
          <Typography variant="s" size="body_long">
            {service.title}
          </Typography>
          <Typography className={productInfoServicePriceWrapper} variant="s" size="body_accent" as="p">
            {prefixPrice ? `${prefixPrice}\u00A0` : ''}{formatToRub(Number(service.price))}&nbsp;₽
          </Typography>
        </Link>
      ))}

      {serviceDisclaimer}
    </div>
  );
};
